import { injectReducer } from "store/reducers";
import AdminEducatorCenterV2Children from "./routes/AdminEducatorCenterV2Children";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "educatorcenter_v2",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "organization-educatorCenterV2" */ "./components"
        ),
        import(
          /* webpackChunkName: "organization-educatorCenterV2" */ "./modules/AdminEducatorCenterV2Module"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "adminEducatorCenterV2",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [AdminEducatorCenterV2Children(store)],
});
